<script>
	import { faLockAlt, faWallet, faHandHoldingUsd, faPlay, faStop, faSolarSystem, faFire, faSparkles } from '@fortawesome/pro-solid-svg-icons'
	import { faSmile } from '@fortawesome/pro-regular-svg-icons'
	import Fa from 'svelte-fa'
  import { map, tap, withLatestFrom, startWith } from 'rxjs/operators';
  import _ from 'lodash'

  export let name
  export let explaination
  export let details
  export let example
</script>

<div class='pt3 pb3 white'>
  <div class='pt1 fw8'> {name} </div>
  <div class='pt1 f6'> {explaination} </div>
  <div class=' pt3 f6'> {details} </div>
  <div class=' pt1 f6'> {example}</div>
</div>


<style>
</style>